const selectors = {
  cursor: '.js-mouse-cursor:not(.is-initialized)',
};

const classes = {
  active: 'is-active',
};

const init = () => {
  const cursors = document.querySelectorAll(selectors.cursor);

  cursors.forEach(cursor => {
    cursor.classList.add('is-initialized');

    const container = cursor.parentElement;

    let mouseX = 0,
      mouseY = 0;
    let currentX = 0,
      currentY = 0;
    const speed = 1;

    const updatePosition = () => {
      const dx = mouseX - currentX;
      const dy = mouseY - currentY;
      currentX += dx * speed;
      currentY += dy * speed;
      cursor.style.setProperty('--cursorX', `${currentX}px`);
      cursor.style.setProperty('--cursorY', `${currentY}px`);

      requestAnimationFrame(updatePosition);
    };

    container.addEventListener('mousemove', e => {
      const rect = container.getBoundingClientRect();
      mouseX = e.clientX - rect.left;
      mouseY = e.clientY - rect.top;
      cursor.classList.add(classes.active);
    });

    container.addEventListener('mouseenter', () => {
      cursor.classList.add(classes.active);
    });

    container.addEventListener('mouseleave', () => {
      cursor.classList.remove(classes.active);
    });

    container.addEventListener('click', () => {
      cursor.classList.remove(classes.active);
    });

    updatePosition();
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
